import React from 'react';

const Menu = ({ height = 48, width = 48, color = '#494949' }) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>menu</title>
    <g fill={color}>
      <circle cx="24" cy="24" r="4"/>
      <circle cx="6" cy="24" fill={color} r="4"/>
      <circle cx="42" cy="24" fill={color} r="4"/>
    </g>
  </svg>
);

export default Menu;
